<template>
    <div>

    </div>
</template>
<script>
import {getTaskDetailItemAPI} from '../../utils/api/taskApi'
export default {
    data() {
        return {
            parentUid: '',
            completeId: '',
            taskInfo: '',
        }
    },
    beforeRouteEnter(to,from,next) {
        console.log('进入中间页面之前',from,to)
        
        if(from.path == '/submitTask' || from.path == '/taskDetail') {
            window.history.go(-1)
        }else {
            next()
        }
    },
    created() {
        console.log('-----进入作业跳转中间页面-----',this.$route)
        if(this.$route.query.completeId && this.$route.query.parentUid) {
            this.parentUid = this.$route.query.parentUid
            this.completeId = this.$route.query.completeId
            this.getDetail()
        }else {
            // this.$router.go(-1)
        }
    },
    methods: {
        getDetail() {
            getTaskDetailItemAPI({completeId: this.completeId}).then(res => {
                console.log('作业详情：',res)
                if(res.resultCode == 200) {
                    this.taskInfo = res.data
                    if(res.data.isSubmit == 1) { // 已提交跳转详情
                        this.$router.replace({name: 'TaskDetail',params:{taskInfo: this.taskInfo,parentUid: this.parentUid}})
                    }else if(res.data.isSubmit == 0) { // 跳转提交页
                        this.$router.replace({name: 'SubmitTask',params:{taskInfo: this.taskInfo,parentUid: this.parentUid}})
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>